import { withErrorBoundary } from "@client/components/utils/ErrorBoundary";
import { cn } from "@client/utils/cn";
import { Text } from "@sfc/ui";

export const RoundPage = withErrorBoundary(
  ({
    className,
    containerClassName,
    title,
    description,
    cta,
    fullWidth = false,
    children,
  }: {
    className?: string;
    containerClassName?: string;
    title: string;
    description?: React.ReactNode;
    cta?: React.ReactNode;
    /**
     * Pages dominated by a wide table (Onboarding, Investigations, Recusals)
     * skip the max-w-content cap so the table can use the whole viewport
     * before falling back to scrolling inside its box.
     */
    fullWidth?: boolean;
    children?: React.ReactNode;
  }) => (
    <div
      className={cn(
        "relative min-h-full p-4 flex mx-auto w-full gap-6 flex-col",
        !fullWidth && "max-w-content",
        containerClassName,
      )}
    >
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
        <header>
          <h1 data-slot="page-title" className="text-2xl font-bold">
            {title}
          </h1>
          {description && (
            <Text size="xs" tone="muted-foreground">
              {description}
            </Text>
          )}
        </header>
        {cta}
      </div>
      <div className={cn("flex-1", className)}>{children}</div>
    </div>
  ),
);
